import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export const useScrollTo = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const scrollToSection = useCallback((sectionId, targetPath = null) => {
    const scrollToElement = () => {
      const element = document.getElementById(sectionId)
      if (element) {
        const headerOffset = 80 // Account for fixed header
        const elementPosition = element.offsetTop
        const offsetPosition = elementPosition - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }

    if (targetPath && location.pathname !== targetPath) {
      navigate(targetPath)
      // Wait for navigation to complete before scrolling
      setTimeout(scrollToElement, 100)
    } else {
      scrollToElement()
    }
  }, [navigate, location.pathname])

  return scrollToSection
}

export default useScrollTo